import React, { useState } from "react";

import Dashboard from "./dashboard/Dashboard";
import DigitalAssets from "../components/dashboard/integrations/DigitalAssets";
import AuthUser from "../services/SignIn";

const Login = () => {
  // check token on local storage
  if (localStorage.getItem("authorized")) {
    // TDOO validasi token
    return <Dashboard />;
  } else {
    return <LoginForm />;
  }
};

async function loginUser(credentials) {
  return fetch(process.env.REACT_APP_HOST_KERJASAMA_BU + "/api/sso/signin", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(credentials),
  }).then((data) => data.json());
}

function getExpiredToken() {
  var today = new Date();

  var expired = today.setDate(today.getDate() + 1);
  return new Date(expired);
}

const LoginForm = () => {
  var md5 = require("md5");
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();

  const [errorEmail, setErrorEmail] = React.useState("");
  const [errorPassword, setErrorPassword] = React.useState("");

  var isExpired = localStorage.getItem("isExpired") ?? false;

  const handleSubmit = async (e) => {
    e.preventDefault();
    const response = await loginUser({
      email,
      password,
    });

    // reset error
    setErrorEmail("");
    setErrorPassword("");

    // handle on error
    if (response["code"] != 200) {
      var field = response["data"]["field"] ?? "";

      if (field == "email") {
        setErrorEmail(response["message"]);
      }

      if (field == "password") {
        setErrorPassword(response["message"]);
      }
    }

    // handle on success
    if (response["code"] == 200) {
      var data = response["data"];

      localStorage.setItem("authorized", data["name"]);
      localStorage.setItem("client_id", data["token"]);
      localStorage.setItem("tokenExpired", getExpiredToken());
      localStorage.setItem("isExpired", false);

      localStorage.setItem("kerjasama_bu", JSON.stringify(data));
      await AuthUser({ email });
      window.location.href = "/";
    }
  };

  return (
    <div
      id="login-page"
      className="flex w-full bg-primary-main bg-login min-h-screen h-screen bg-no-repeat p-8 px-20"
    >
      {/* Assest Digital */}
      <div className="flex flex-1 items-center justify-center p-2 text-4xl">
        <div className="w-full p-8">
          <h1 className="text-xl text-center font-medium text-white">
            Selamat Datang
          </h1>
          <h1 className="text-xl text-center font-medium text-white">
            di Portal Pendapatan BAKTI
          </h1>

          <div className="my-8">
            <DigitalAssets />
          </div>

          <h2 className="text-lg font-medium text-white mb-8">
            Asset Digital Divisi Pendapatan
          </h2>

          <p className="text-white text-base">
            Pihak yang berhubungan dengan divisi pendapatan, dapat mengakses
            langsung asset digital Divisi Pendapatan BAKTI: (1) KPU/USO, (2)
            Kerjasama BU, (3) Perbankan, dan (4) Pendapatan Lain-Lain
          </p>
        </div>
      </div>

      {/* Form Login */}
      <div className="flex flex-1 items-center justify-center p-2 text-4xl">
        <form action="" onSubmit={handleSubmit}>
          <div className="p-8">
            <div className="bg-white p-8 w-full rounded-md shadow-md flex flex-col justify-start gap-4">
              <div>
                <img
                  src={
                    window.location.origin +
                    process.env.REACT_APP_BASE_PATH +
                    "assets/images/logo-bakti.png"
                  }
                  alt="icon"
                  className="object-scale-down h-10"
                />
              </div>
              <h1 className="text-2xl font-bold">Login Portal</h1>

              {isExpired && (
                <label
                  htmlFor="error"
                  className="text-danger text-xs"
                  id="errorEmail"
                >
                  Sesi anda telah habis. Silahkan login kembali.
                </label>
              )}

              {/* email */}
              <div className="flex flex-col gap-2 mt-4">
                <label htmlFor="email" className="text-neutral-500 text-sm">
                  Email
                </label>
                <input
                  type="text"
                  id="email"
                  name="email"
                  placeholder="user@baktikominfo.id"
                  className="w-full p-1 border border-neutral-300 rounded-md text-sm focus:border-primary-dark focus:outline-none focus:ring-primary-main"
                  onChange={(e) => setEmail(e.target.value)}
                />
                {errorEmail && (
                  <label
                    htmlFor="error"
                    className="text-danger text-xs"
                    id="errorEmail"
                  >
                    {errorEmail}
                  </label>
                )}
              </div>

              {/* Password */}
              <div className="flex flex-col gap-2">
                <label htmlFor="password" className="text-neutral-500 text-sm">
                  Password
                </label>
                <input
                  type="password"
                  id="password"
                  name="password"
                  placeholder="********"
                  className="w-full p-1 border border-neutral-300 rounded-md text-sm focus:border-primary-dark focus:outline-none focus:ring-primary-main"
                  onChange={(e) => setPassword(e.target.value)}
                />
                {errorPassword && (
                  <label
                    htmlFor="error"
                    className="text-danger text-xs"
                    id="errorPassword"
                  >
                    {errorPassword}
                  </label>
                )}
              </div>

              <button
                type="submit"
                className="w-full bg-white hover:bg-primary-main hover:text-white p-2 border border-neutral-300 font-semibold rounded-md text-base text-center mt-6 duration-300"
              >
                Login
              </button>

              <div className="flex py-4 border-t border-gray-200 justify-center gap-4 items-center mt-6">
                <span className="text-gray-400 text-sm">
                  Didukung oleh lembaga:
                </span>
                <img
                  src={
                    window.location.origin +
                    process.env.REACT_APP_BASE_PATH +
                    "assets/images/logo-bsre.png"
                  }
                  alt="icon"
                  className="object-scale-down h-8"
                />
              </div>

              <div className="grid grid-cols-2 mt-4">
                <div className="text-primary-second font-semibold">
                  <p className="text-sm">
                    Copyright &copy; 2023 Divisi Pendapatan Direktorat Keuangan
                    BAKTI Kominfo
                  </p>
                </div>
                <div className="text-primary-second text-right font-semibold">
                  <p className="text-sm">
                    Develop by{" "}
                    <a
                      href="https://reksa.co.id/"
                      className="underline"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Reksa Karya
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
